import React from 'react';
import { tickers } from '../data/content';
import { CandleChart } from './charts/CandleChart';
import { Sparkline } from './charts/Sparkline';
import { ReferralButton } from './ReferralButton';
import { Reveal } from './Reveal';
import { Logo } from './Logo';
export function MobileSection() {
  return <section className="border-y border-hairline bg-surface px-5 py-24 lg:px-8 lg:py-32" data-id="element-157" data-mp="3qguy3ryji9wj">
      <div className="mx-auto grid max-w-shell items-center gap-16 lg:grid-cols-[0.85fr_1.15fr]" data-id="element-158" data-mp="3vg7p8owg234x">
        <Reveal className="order-2 lg:order-1" data-id="element-159" data-mp="48vbykyom9ua">
          <PhoneMockup data-id="element-160" data-mp="47k346qdqbwb" />
        </Reveal>

        <Reveal delay={0.08} className="order-1 lg:order-2" data-id="element-161" data-mp="97yadmk5phta">
          <h2 className="max-w-[520px] text-[30px] font-extrabold uppercase leading-[1] tracking-tightest text-white sm:text-[42px]" data-id="element-162" data-mp="96ddhqaddms9">
            Tu mercado, donde lo necesites.
          </h2>
          <p className="mt-5 max-w-[480px] text-[15px] leading-relaxed text-ink-muted" data-id="element-163" data-mp="2b1nuwi4etnz8">
            Consulta mercados y utiliza las herramientas disponibles desde dispositivos compatibles.
          </p>
          <ReferralButton location="mobile_section" size="lg" showArrow className="mt-9" data-id="element-164" data-mp="3mquwobno4vqw">
            Crear cuenta
          </ReferralButton>
        </Reveal>
      </div>
    </section>;
}
function PhoneMockup() {
  return <div className="relative mx-auto w-full max-w-[300px]" data-id="element-165" data-mp="3804616xtc2pd">
      <div className="pointer-events-none absolute -inset-8 -z-10 opacity-80" style={{
      background: 'radial-gradient(50% 45% at 50% 45%, rgba(247,162,59,0.2), rgba(5,5,5,0) 70%)'
    }} aria-hidden="true" data-id="element-166" data-mp="381p1qzvv5rot" />
      <div className="rounded-[42px] border border-white/12 bg-black p-2.5 shadow-[0_50px_120px_-40px_rgba(0,0,0,0.95)]" data-id="element-167" data-mp="3vondjk91gbge">
        <div className="overflow-hidden rounded-[34px] border border-hairline bg-base" data-id="element-168" data-mp="3qptz9plxggf6">
          <div className="flex items-center justify-between px-5 pb-2 pt-4" data-id="element-169" data-mp="2kb2sj5a4i1d8">
            <span className="text-[10px] font-medium text-ink-muted" data-id="element-170" data-mp="2faosa9erjvpr">9:41</span>
            <span className="h-1.5 w-14 rounded-full bg-white/12" aria-hidden="true" data-id="element-171" data-mp="17c0xctbdpkzn" />
            <span className="text-[10px] font-medium text-ink-muted" data-id="element-172" data-mp="179wso95nohyb">100%</span>
          </div>

          <div className="px-5 pb-6 pt-3" data-id="element-173" data-mp="1bb0a303cqm1n">
            <Logo className="scale-[0.85] origin-left" data-id="element-174" data-mp="xcifcif149a8" />

            <div className="mt-5 rounded-2xl border border-hairline bg-card p-4" data-id="element-175" data-mp="xfxzhznk88ii">
              <div className="flex items-center justify-between" data-id="element-176" data-mp="12erc7pv0vvhm">
                <span className="text-[13px] font-semibold text-white" data-id="element-177" data-mp="nmyvb9fky9ds">BTC/USDT</span>
                <span className="text-[12px] font-semibold text-gain" data-id="element-178" data-mp="seqrq0lf39bu">+2.45%</span>
              </div>
              <CandleChart height={104} seed={11} count={18} showAxis={false} className="mt-3" data-id="element-179" data-mp="eo53rxh3w973" />
            </div>

            <p className="mt-5 text-[9.5px] font-semibold uppercase tracking-[0.18em] text-ink-muted" data-id="element-180" data-mp="jmyjlwjv8caf">
              Mercados
            </p>
            <ul className="mt-2.5 space-y-2" data-id="element-181" data-mp="9nzjj2d61oz1">
              {tickers.map(t => <li key={t.pair} className="flex items-center justify-between gap-2 rounded-xl border border-hairline px-3 py-2" data-id="element-182" data-mp="9q3ir704dzsz">
                  <span className="text-[11.5px] font-medium text-white" data-id="element-183" data-mp="3i7t3xvkgsy30">{t.pair}</span>
                  <Sparkline points={t.trend} positive={t.change >= 0} className="!w-9" data-id="element-184" data-mp="1yb1m757smv" />
                  <span className={`w-12 text-right text-[11px] font-semibold tabular-nums ${t.change >= 0 ? 'text-gain' : 'text-loss'}`} data-id="element-185" data-mp="3r5wpuszd3wvc">
                    {t.change >= 0 ? '+' : ''}
                    {t.change.toFixed(2)}%
                  </span>
                </li>)}
            </ul>

            <div className="mt-5 flex h-10 items-center justify-center rounded-full bg-brand text-[11px] font-semibold uppercase tracking-[0.08em] text-black" data-id="element-186" data-mp="dstak7vr4xds">
              Crear cuenta
            </div>
          </div>
        </div>
      </div>
      <p className="mt-4 text-center text-[11px] text-white/30" data-id="element-187" data-mp="nnv2tclbqfkl">
        Mockup ilustrativo con datos ficticios.
      </p>
    </div>;
}